import React from 'react';

import {makeStyles} from '@mui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../../components/displaycard';
import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';

const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 345,
    },
}));

const options = [
    {
        title: 'Users & Roles',
        description: 'Create and update users and roles',
        img: '/images/users-roles.png',
        route: '/system/users_roles',
        perm: {
            Users: [...Permissions.System.Users],
            Roles: [...Permissions.System.Roles],
        },
    },
    {
        title: 'Configuration',
        description: 'Manage settings for health, reports, audits, etc.',
        img: '/images/configuration.png',
        route: '/system/configuration',
        perm: { ...Permissions.System.Configuration },
    },
    {
        title: 'MC2 Health',
        description: 'Extensive reporting on the health of the MC2',
        img: '/images/health.png',
        route: '/system/mc2_health',
        perm: { SystemHealth: [...Permissions.System.SystemHealth] },
    },
    {
        title: 'MC2 Upgrades',
        description: 'Upgrade MC2',
        img: '/images/update.png',
        route: '/system/upgrades_mc2',
        perm: { Mc2Upgrades: [...Permissions.System.Upgrades.Mc2Upgrades] },
    },
    {
        title: 'Audit',
        description: 'A report of audited user actions on the OpenText™ NDR system',
        img: '/images/audit.png',
        route: '/system/audit',
        perm: { Audit: [...Permissions.System.Audit] },
    },
    {
        title: 'Audit Reports',
        description: 'View previously exported audit reports',
        img: '/images/reports.png',
        route: '/system/audit_reports',
        perm: { Audit: [...Permissions.System.Audit] },
    },
];

const System = (props) => {
    const classes = useStyles();

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {options.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`system-${i}`}>
                            <DisplayCard {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default System;
